/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		UserTypeFactory,
		AlertService,
		NoPagingUserTypeFactory,
		NoPagingPredefinedUserTypeFactory
	) {
		$scope.userType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.userType) && $rootScope.isDefinedAndNotNull($scope.userType.id);
		};

		$scope.createPredefinedUserType = function() {
			var referredBy = {
				refName: 'predefinedUserType',
				data: $scope.userType,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new predefinedUserType will add this new usertype state to the history stack
				$state.go('usertype.list.newPredefinedUserType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('userType.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type PredefinedUserType and checks if this UserType dialog is called in the context of PredefinedUserType.
		 * If this is the case, we detect the parent entity UserType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPredefinedUserType = function() {
			return NoPagingPredefinedUserTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'predefinedUserType');
			});
		};
		$scope.predefinedUserTypeList = $scope.queryPredefinedUserType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:userTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving UserType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.userType.id != null) {
				UserTypeFactory.update($scope.userType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				UserTypeFactory.save($scope.userType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});
